<ng-container *ngIf="auth.isLoggedIn(); else publicPage">
  <div
    class="app-shell"
    [class.nav-collapsed]="collapsed"
    [class.mobile-nav-open]="mobileNavOpen"
  >
    <button
      class="mobile-backdrop"
      type="button"
      aria-label="Close navigation"
      (click)="mobileNavOpen = false"
    ></button>
    <aside class="sidebar">
      <div class="brand">
        <div class="brand-mark">
          <mat-icon>settings_suggest</mat-icon>
        </div>
        <div class="brand-copy">
          <strong>PMS</strong>
          <span>Production Control</span>
        </div>
        <button
          class="collapse-btn"
          type="button"
          (click)="collapsed = !collapsed"
          [attr.aria-label]="
            collapsed ? 'Open navigation' : 'Collapse navigation'
          "
        >
          <mat-icon>{{
            collapsed
              ? "keyboard_double_arrow_right"
              : "keyboard_double_arrow_left"
          }}</mat-icon>
        </button>
      </div>

      <nav>
        <div
          class="nav-section"
          *ngFor="let group of navGroups; trackBy: trackNavGroup"
        >
          <span class="section-label">{{ group.section }}</span>
          <a
            *ngFor="let item of group.items; trackBy: trackNavItem"
            [routerLink]="item.path"
            routerLinkActive="active"
            [title]="collapsed ? item.label : ''"
            (click)="mobileNavOpen = false"
          >
            <mat-icon class="nav-icon">{{ item.icon }}</mat-icon>
            <span>{{ item.label }}</span>
          </a>
        </div>
      </nav>

      <div class="sidebar-footer">
        <button class="logout-btn" type="button" (click)="logout()">
          <mat-icon>logout</mat-icon>
          <span>Logout</span>
        </button>
      </div>
    </aside>

    <main class="main">
      <header class="topbar">
        <div class="topbar-title">
          <button
            class="hamburger-btn"
            type="button"
            (click)="mobileNavOpen = true"
            aria-label="Open navigation"
          >
            <mat-icon>menu</mat-icon>
          </button>
          <div>
            <span class="eyebrow">{{ headerSubtitle }}</span>
            <h1>{{ headerTitle }}</h1>
          </div>
        </div>
        <div class="header-actions">
          <div class="notification-wrap">
            <button
              class="notification-btn"
              type="button"
              title="Low stock notifications"
              (click)="
                notificationsOpen = !notificationsOpen;
                loadLowStockNotifications()
              "
            >
              <mat-icon>notifications</mat-icon>
              <span
                class="notification-badge"
                *ngIf="lowStockMaterials.length"
                >{{ lowStockMaterials.length }}</span
              >
            </button>
            <div class="notification-panel" *ngIf="notificationsOpen">
              <div class="notification-head">
                <strong>Low material stock</strong>
                <span>Below 50 quantity</span>
              </div>
              <div class="notification-empty" *ngIf="!lowStockMaterials.length">
                No low-stock materials
              </div>
              <div
                class="notification-item"
                *ngFor="let material of lowStockMaterials"
              >
                <strong>{{ material.materialNumber }}</strong>
                <span>{{ material.description }}</span>
                <em>Available: {{ material.availableQuantity }}</em>
              </div>
            </div>
          </div>
          <div class="profile-chip">
            <button class="profile-avatar" type="button" title="Profile">
              {{ auth.currentUser()?.name?.charAt(0) }}
            </button>
            <div class="profile-copy">
              <strong>{{ auth.currentUser()?.name }}</strong>
              <span>{{ auth.currentUser()?.role }}</span>
            </div>
            <mat-icon>keyboard_arrow_down</mat-icon>
          </div>
          <!-- <button class="logout-btn" type="button" (click)="logout()">
            <mat-icon>logout</mat-icon>
            <span>Logout</span>
          </button> -->
        </div>
      </header>
      <section class="content">
        <router-outlet />
      </section>
    </main>
  </div>
</ng-container>

<ng-template #publicPage>
  <router-outlet />
</ng-template>

<app-toast-stack />
